document.addEventListener('DOMContentLoaded', function () {
  var wa = document.querySelector('.carni-whatsapp');
  if (!wa) return;
  var btt = document.querySelector('back-to-top');
  if (!btt) return; // no back-to-top on the page, WhatsApp just stays in the corner
  // Keep WhatsApp in sync with the back-to-top's visibility so they never overlap.
  function sync() { wa.classList.toggle('is-raised', btt.classList.contains('show')); }
  new MutationObserver(sync).observe(btt, { attributes: true, attributeFilter: ['class'] });
  sync();
});
// The consent app's "Cookie Preferences" button. It lives inside the open shadow root of
// <csm-cookie-consent> (#reopen_widget in a fixed wrapper), which is why the old light-DOM
// text search never found it and it sat on top of the cart drawer's View Cart button
// (owner report, 2026-10-14). Park it above the loyalty launcher in the left column, and
// hide it while any drawer or modal is open (body.modal-show) or the mobile quick search is
// open (body.search-open), like the launcher.
(function () {
  var STYLE_ID = 'carni-csm-tidy';

  function wire(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    if (!root.getElementById(STYLE_ID)) {
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.textContent = ':host(.carni-modal-open) .carni-csm-reopen{display:none !important;}';
      root.appendChild(st);
    }
    // Mirror the theme's modal state onto the host so the shadow rule above can see it.
    function syncModal() { var c = document.body.classList; host.classList.toggle('carni-modal-open', c.contains('modal-show') || c.contains('search-open')); }
    new MutationObserver(syncModal).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    syncModal();

    function park() {
      var w = root.getElementById('reopen_widget');
      if (!w) return;
      var box = w;
      while (box && box.parentNode !== root && getComputedStyle(box).position !== 'fixed') box = box.parentElement;
      if (!box || box.classList.contains('carni-csm-reopen')) return;
      box.classList.add('carni-csm-reopen');
      box.style.setProperty('left', '1.6rem', 'important');
      box.style.setProperty('right', 'auto', 'important');
      box.style.setProperty('top', 'auto', 'important');
      box.style.setProperty('bottom', 'calc(var(--mobile-sticky-bar-height, 0px) + var(--sticky-atc-bar-height, 0px) + 8.6rem)', 'important');
    }
    // The widget only appears after the visitor answers the banner, which can be any
    // time, so watch the (small) shadow tree rather than the whole page.
    park();
    new MutationObserver(park).observe(root, { childList: true, subtree: true });
    return true;
  }

  var host = document.querySelector('csm-cookie-consent');
  if (host && wire(host)) return;
  var mo = new MutationObserver(function () {
    var h = document.querySelector('csm-cookie-consent');
    if (h && h.shadowRoot && wire(h)) mo.disconnect();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 20000);
})();
